export default __webpack_public_path__ + "static/logo-philip-morris-international-e32f3cf3e7dcfad76d911f3c3c422daf.png";